import handler from './Handler'

export default ({
  // Auth
  login: form => handler.post('/auth/login', form),
  refreshToken: params => handler.get('/auth/token', { params }),
  getMe: () => handler.get('/users/me/profile'),
  getPermissions: () => handler.get('/users/me/permissions'),
  logout: () => handler.post('/auth/logout'),

  // Vessel Transactions
  getVesselTransactions: params => handler.get('/vessel-transactions', { params }),

  // Telematics
  getPositions: params => handler.get('/telematics/tugboats-position', { params }),
  getTugboatRoutes: params => handler.get('/telematics/tugboats-routes', { params }),
  downloadPositions: params => handler.get('/telematics/tugboats-position/download', {
    params,
    responseType: 'blob'
  }),
  tugboatRoutesDownload: params => handler.get('/telematics/tugboats-routes/download', {
    params,
    responseType: 'blob'
  }),
  getBargeStatus: params => handler.get('/barge-status', { params }),

  // Point of Interests
  getPois: () => handler.get('/point-of-interests/list/eta'),
  getRoutes: params => handler.get('/point-of-interests/list/routes', { params }),

  // Schedule Of Shipment
  postThirdPartyConfig: form => handler.post('/sos/third-party-coal', form),
  uploadFile: (form, onUploadProgress) => handler.post('/sos/upload', form, { onUploadProgress }),
  getSos: (id, params) => handler.get(id ? `/sos/${id}` : '/sos', { params }),
  postSos: form => handler.post('/sos', form),

  // Sales Plan
  uploadSalesPlan: (form, onUploadProgress) => handler.post('/sales-plans/upload', form, { onUploadProgress }),
  postSalesPlan: form => handler.post('/sales-plans', form),
  getRevisionList: () => handler.get('/sales-plans/revision'),
  getSalesPlan: id => handler.get(`/sales-plans/${id}`),
  getSalesPlanList: params => handler.get('/sales-plans', { params }),
  getSalesPlanMonthlyLog: params => handler.get('/sales-plans/log', { params }),

  // Vessel Line Up
  getEndUser: (id, params) => handler.get(id ? `/sos/detail/${id}` : '/sos/detail', { params }),
  getAgencies: () => handler.get('/agencies'),
  getLoadingFacilities: () => handler.get('/loading-facilities'),
  getFlfFcNominates: () => handler.get('/flf-fc-nominates'),
  getFlfFcNominatesByLoadingFacility: (id) => handler.get(`/flf-fc-nominates/${id}`),
  getVesselTypes: () => handler.get('/vessel-types'),
  getVessel: () => handler.get('/vessel-line-ups/vessel'),
  getVesselLineUpList: params => handler.get('/vessel-line-ups', { params }),
  getVesselLineUpDetail: id => handler.get(`/vessel-line-ups/${id}`),
  postVesselLineUp: form => handler.post('/vessel-line-ups', form),
  putVesselLineUp: (id, form) => handler.put(`/vessel-line-ups/${id}`, form),
  getVesselLineUpLog: id => handler.get(`/vessel-line-ups/log/${id}`),
  getVesselLineUpHistories: id => handler.get(`/vessel-line-ups/histories/${id}`),
  getVesselLineUpExcelDownload: (params) => handler.get('/vessel-line-ups/download', { params, responseType: 'blob' }),
  getVesselLineUpTBSExcelDownload: (params) => handler.get('/vessel-line-ups/download-tentative-barge-schedule-ssrs', { params, responseType: 'blob' }),
  getOptionsPol: () => handler.get('/vessel-line-ups/pol'),
  getOptionsStatus: () => handler.get('/vessel-line-ups/status'),
  postVesselLineUpSync: () => handler.post('/vessel-line-ups/sync-from-iod'),
  postVesselLineUpSendToFLF: () => handler.post('/vessel-line-ups/send-ongoing-tentative-barge-schedule'),

  // Loading Plan
  uploadLoadingPlan: (form, vlu_id, onUploadProgress) => handler.post(`/loading-plans/upload?vlu_id=${vlu_id}`, form, { onUploadProgress }),
  postLoadingPlan: form => handler.post('/loading-plans', form),
  getLatestLoadingPlan: id => handler.get(`/loading-plans/latest/${id}`),
  getVLULoadingPlan: (id) => handler.get(`/barge-line-ups/vlu/${id}`),
  getLoadingPlans: (id, params) => handler.get(`/loading-plans/${id}`, {params}),
  putLoadingPlansUpdate: form => handler.put('/loading-plans/update', form),

  // Tentative Barge Schedule
  getBlendingSchemes: () => handler.get('/blending-schemes'),
  postBlendingSchemes: form => handler.post('/blending-schemes', form),

  // Barge Line Up
  getBargeLineUp: params => handler.get('/barge-line-ups', { params }),
  getBargeLineUpDetail: (id, is_blu_return_cargo, params) => handler.get(`/barge-line-ups/${id}?is_blu_return_cargo=${is_blu_return_cargo}`, { params }),
  postBargeLineUp: form => handler.post('/barge-line-ups', form),
  putBargeLineUp: (id, form) => handler.put(id ? `/barge-line-ups/${id}` : '/barge-line-ups', form),
  putBargeLineUpActual: (id, form) => handler.put(`/barge-line-ups/${id}/actual`, form),
  putBulkBargeLineUp: (form) =>handler.put(`/barge-line-ups/bulk-edit`, form),
  getBargeDropdown: params => handler.get('/barge-line-ups/barge', { params }),
  getTugDropdown: params => handler.get('/barge-line-ups/tug', { params }),
  getTermDropdown: params => handler.get('/barge-line-ups/term', { params }),
  getVesselDropdown: params => handler.get('/barge-line-ups/vessel', { params }),
  getThirdPartyDropdown: (vesselId, params) => handler.get(`/barge-line-ups/vessel/${vesselId}`, { params }),
  getProductIdDropdown: (vesselId, params) => handler.get(`/barge-line-ups/vessel/${vesselId}/product`, { params }),
  getDropdownOptionsBLU: params => handler.get('/barge-line-ups/dropdown', { params }),
  getPolDropdown: params => handler.get('/type-of-ports/pol', { params }),
  getPodDropdown: params => handler.get('/type-of-ports/pod', { params }),
  postPolPodDropdown: params => handler.post('/type-of-ports', null, { params }),
  getRouteDropdown: params => handler.get('/barge-line-ups/route', { params }),
  getProductDropdown: params => handler.get('/barge-line-ups/product', { params }),
  getKpiDropdown: params => handler.get('/barge-line-ups/kpi-code', { params }),
  getLatestPol: params => handler.get('/barge-line-ups/latest-pol', { params }),
  getLatestPod: params => handler.get('/barge-line-ups/latest-pod', { params }),
  getBargeLineUpLog: (id, params) => handler.get(`/barge-line-ups/logs/${id}`, { params }),
  getBargeLineUpIdByTugName: (params) => handler.get('/barge-line-ups/blu-tug', { params }),
  downloadBargeLineUps: params => handler.get('/barge-line-ups/download', { params, responseType: 'blob' }),
  getBargeLineUpHistories: (id, params) => handler.get(`/barge-line-ups/histories/${id}`, { params }),
  postBargeLineUpUpload: (form, onUploadProgress) => handler.post('/barge-line-ups/upload', form, { onUploadProgress }),
  getBargeLineUpUploadColumnConfig: () => handler.get('/barge-line-ups/upload/column-config'),
  postBargeLineUpConfig: form => handler.post('/barge-line-ups/product-coal', form),
  postBargeLineUpValidateRow: form => handler.post('/barge-line-ups/validate-row', form),
  postBargeLineUpGenerate: form => handler.post('/barge-line-ups/generate-blu', form),
  getBargeLineUpDetailPlan: id => handler.get(`/barge-line-ups/${id}/plan`),
  postCalculatedSimulation: (id, is_blu_return_cargo, form) => handler.post(`/barge-line-ups/${id}/simulate-checkpoint?is_blu_return_cargo=${is_blu_return_cargo}`, form),
  putBulkAssignBlu: (form) => handler.put(`/barge-line-ups/bulk-doc-assignment`, form),
  deleteBulkDeleteBlu: (form) => handler.delete(`/barge-line-ups/bulk-delete`, { data: form }),
  postReturnCargo: (id, form) => handler.post(`/barge-line-ups/${id}/return-cargo`, form),
  postSendEmailBlu: () => handler.post('/barge-line-ups/send-email'),

  // Delay Time
  uploadDelayTime: (form, onUploadProgress) => handler.post('/delay-times/upload', form, { onUploadProgress }),
  postDelayTime: form => handler.post('/delay-times', form),
  getLatestDelayTime: id => handler.get(`/delay-times/latest/${id}`),

  // Port Stock Yard
  getPortStockYard: params => handler.get('/port-stock-yards', { params }),
  getPortStockYardOverview: params => handler.get('/barge-line-ups/psy-overview', { params }),
  putPortStockYard: form => handler.put('/port-stock-yards', form),

  // Barge Capacity
  getBargeCapacities: params => handler.get('/fleet-arrangement/barge-capacity', { params }),
  downloadBargeCapacities: params => handler.get('/fleet-arrangement/barge-capacity/download', { params, responseType: 'blob' }),

  // Cycle Time
  getCycleTimes: params => handler.get('/fleet-arrangement/cycle-times', { params }),
  downloadCycleTime: params => handler.get('/fleet-arrangement/cycle-times/download', { params, responseType: 'blob' }),

  // Tonnage Plan
  getTonnagePlans: params => handler.get('/fleet-arrangement/tonnage-plans', { params }),
  downloadTonnagePlan: params => handler.get('/fleet-arrangement/tonnage-plans/download', { params, responseType: 'blob' }),

  // Fleet Requirement
  getFleetRequirements: () => handler.get('/fleet-arrangement/fleet-requirement'),
  downloadFleetRequirements: () => handler.get('/fleet-arrangement/fleet-requirement/download', { responseType: 'blob' }),

  // Contract Management
  getContracts: params => handler.get('/contract-managements', { params }),
  getContractDetail: (id, params) => handler.get(`/contract-managements/${id}`, { params }),
  getMasterDropdown: params => handler.get('/contract-managements/masters', { params }),
  getBargeList: params => handler.get('/contract-managements/barges', { params }),
  getTugList: params => handler.get('/contract-managements/tugs', { params }),
  getBargeCertificates: id => handler.get(`/contract-managements/barges/certificates/${id}`),
  getTugCertificates: id => handler.get(`/contract-managements/tugs/certificates/${id}`),
  postBargeCertificates: (id, form) => handler.put(`/contract-managements/barges/certificates/${id}`, form),
  postTugCertificates: (id, form) => handler.put(`/contract-managements/tugs/certificates/${id}`, form),
  uploadAttachment: form => handler.post('/contract-managements/attachments', form, { timeout: 1200000 }),
  deleteAttachment: id => handler.delete(`/contract-managements/attachments/${id}`),
  postContract: form => handler.post('/contract-managements', form),
  putContract: (id, form) => handler.put(`/contract-managements/${id}`, form),
  deleteContract: id => handler.delete(`/contract-managements/${id}`),
  getContractNotification: params => handler.get('/contract-managements/end', { params }),
  getCertificateNotification: params => handler.get('/contract-managements/certificates/expire', { params }),
  getContractLog: params => handler.get('/contract-managements/logs', { params }),
  putBargeActiveState: (id, form) => handler.put(`/contract-managements/barges/${id}`, form),
  putTugActiveState: (id, form) => handler.put(`/contract-managements/tugs/${id}`, form),

  // Reports
  getUsernames: params => handler.get('/users/username', { params }),
  getUserLocations: params => handler.get('/users/location', { params }),
  getUserLogs: params => handler.get('/user-logs', { params }),
  postUserLog: (form, params) => handler.post('/user-logs', form, { params }),
  downloadLogs: params => handler.get('/user-logs/download', { params, responseType: 'blob' }),
  getCompanies: () => handler.get('/companies'),
  getTugsNames: params => handler.get('/tugs/list', { params }),
  getMonitoringReport: params => handler.get('/monitoring-report/datatables', { params }),
  downloadMonitoringReport: params => handler.get('/monitoring-report/download', {
    params,
    responseType: 'blob'
  }),
  getDailyTripActivities: params => handler.get('/daily-trip-activities', { params }),
  postEmailDailyTripActivities: () => handler.post('/daily-trip-activities/send-daily-report'),
  getBargeReport: params => handler.get('/barge-lineup-report/datatables', { params }),
  downloadBargeReport: params => handler.get('/barge-lineup-report/download', {
    params,
    responseType: 'blob'
  }),
  getApproachingTugs: params => handler.get('/notification-users', { params }),
  // Barge Performance
  getBargePerformance: (id, params) => handler.get(`/barge-performances/${id}`, { params }),
  getBargePerformances: params => handler.get('/barge-performances', { params }),
  getTugOwners: () => handler.get('/barge-performances/tug-owners'),
  postCompanyPerformance: form => handler.post('/barge-performances/company-performance', form),

  // Barge Management
  getOwnerNames: () => handler.get('/barge-managements/owner'),
  getBargeManagements: params => handler.get('/barge-managements', { params }),
  getBargeManagementsExcelDownload: params => handler.get('/barge-managements/download', { params, responseType: 'blob' }),
  getBargeManagementDetail: id => handler.get(`/barge-managements/${id}`),
  postBargeManagement: form => handler.post('/barge-managements', form),
  putBargeManagement: (id, form) => handler.put(`/barge-managements/${id}`, form),
  deleteBargeManagement: id => handler.delete(`/barge-managements/${id}`),

  // Tug Management
  getOwners: () => handler.get('/tug-management/owner'),
  getHorsePowers: () => handler.get('/tug-management/horse-powers'),
  getTugManagements: params => handler.get('/tug-management', { params }),
  getTugManagementsExcelDownload: params => handler.get('/tug-management/download', { params, responseType: 'blob' }),
  getTugManagementDetail: id => handler.get(`/tug-management/${id}`),
  postTugManagement: form => handler.post('/tug-management', form),
  putTugManagement: (id, form) => handler.put(`/tug-management/${id}`, form),
  deleteTugManagement: id => handler.delete(`/tug-management/${id}`),

  // Tug Barges
  getTugBarges: params => handler.get('/tug-barges', { params }),
  getTugBargesDropdown: params => handler.get('/tug-barges/tug-barge-dropdown', { params }),
  getTugBargesContractDropdown: params => handler.get('/tug-barges/tug-barge-contract-dropdown', { params }),
  downloadTugBarges: params => handler.get('/tug-barges/download', { params, responseType: 'blob' }),
  postTugBarge: form => handler.post('/tug-barges', form),
  putTugBarge: (id, form) => handler.put(`/tug-barges/${id}`, form),
  deleteTugBarge: id => handler.delete(`/tug-barges/${id}`),
  getSecurityVendors: params => handler.get('/tug-barges/security-vendor', { params }),

  // Group
  getGroups: params => handler.get('/groups', { params }),
  postGroup: form => handler.post('/groups', form),
  putGroup: (id, form) => handler.put(`/groups/${id}`, form),
  deleteGroup: id => handler.delete(`/groups/${id}`),

  // Permission
  getPermissionGroup: params => handler.get('/permissions/group-lists', { params }),
  getPermissionByGroup: (id, params) => handler.get(`/permissions/${id}`, { params }),
  putPermission: (id, form) => handler.put(`/permissions/${id}`, form),

  // User
  getUsers: params => handler.get('/users', { params }),
  getUserAd: params => handler.get('/users/ldap', { params }),
  getUserDetail: (id, params) => handler.get(`/users/${id}`, { params }),
  postUser: form => handler.post('/users', form),
  putUser: (id, form) => handler.put(`/users/${id}`, form),
  deleteUser: id => handler.delete(`/users/${id}`),

  // Companies
  getCompanies: (params) => handler.get('/companies', { params }),
  getCompaniesExcelDownload: (params) => handler.get('/companies/download', { params, responseType: 'blob' }),
  getCompaniesDetails: (params) => handler.get('/companies/details', { params }),
  getSites: (params) => handler.get('/sites', { params }),
  getCompaniesDropdown: (params) => handler.get('/companies/dropdown', { params }),
  getThirdParties: (params) => handler.get('/companies/third-parties', { params }),
  postCompany: (form) => handler.post('/companies', form),
  putCompany: (id, form) => handler.put(`/companies/${id}`, form),
  deleteCompany: (id) => handler.delete(`/companies/${id}`),

  // Agency Management
  getAgencyManagements: (params) => handler.get('/agencies', { params }),
  getAgencyManagementsExcelDownload: (params) => handler.get('/agencies/download', { params, responseType: 'blob' }),
  getAgencyManagementByName: (params) => handler.get('/agencies/details', { params }),
  postAgencyManagement: (form) => handler.post('/agencies', form),
  putAgencyManagement: (id, form) => handler.put(`/agencies/${id}`, form),
  deleteAgencyManagement: (id) => handler.delete(`/agencies/${id}`),

  // Fuel Consumption
  getFuelSupplyTugboats: (params) => handler.get('/fuel-supply-tugboats', { params }),
  postFuelSupplyTugboat: (form) => handler.post('/fuel-supply-tugboats', form),
  putFuelSupplyTugboat: (id, form) => handler.put(`/fuel-supply-tugboats/${id}`, form),
  deleteFuelSupplyTugboat: (id) => handler.delete(`/fuel-supply-tugboats/${id}`),
  getFuelSupplyTugboatsExcelDownload: (params) => handler.get('/fuel-supply-tugboats/download', { params, responseType: 'blob' }),
  
  // Key Activity & Status
  getKeyActivities: (params) => handler.get('/key-activities', { params }),
  postKeyActivity: (form) => handler.post('/key-activities', form),
  putKeyActivity: (id, form) => handler.put(`/key-activities/${id}`, form),
  deleteKeyActivity: (id) => handler.delete(`/key-activities/${id}`),
  postKeyStatus: (form) => handler.post('/key-activities/status', form),
  putKeyStatus: (id, form) => handler.put(`/key-activities/status/${id}`, form),
  deleteKeyStatus: (id) => handler.delete(`/key-activities/status/${id}`),
  getKeyActivityOptions: (params) => handler.get('/key-activities/dropdown', { params }),
  uploadKeyActivityFile: (form, onUploadProgress) => handler.post('/key-activities/attachments', form, { onUploadProgress }),
  uploadKeyStatusFile: (form, onUploadProgress) => handler.post('/key-activities/status/attachments', form, { onUploadProgress }),
  exportKeyActivity: (params) => handler.get('/key-activities/download', { params, responseType: 'blob' }),
  getTripStatus: (params) => handler.get('/key-activities/trip-status', { params }),
  postTripStatus: (form) => handler.post('/key-activities/trip-status', form),
  putTripStatus: (id, form) => handler.put(`/key-activities/trip-status/${id}`, form),
  deleteTripStatus: (id) => handler.delete(`/key-activities/trip-status/${id}`),
  getOeeLvl2: () => handler.get('/key-activities/oee-lv2'),
  getOeeMasters: () => handler.get('/key-activities/oee-masters'),
  getActivityStatus: (id) => handler.get(`/key-activities/${id}/status`),
  getActivityStatusByTripStatus: (id) => handler.get(`/key-activities/activity-status/${id}`),

  // Freight Cost
  getSpotCostDetails: (params) => handler.get('/contract-managements/spot-cost/details', { params }),
  postSpotCost: (form) => handler.post('/contract-managements/spot-cost', form),
  putSpotCost: (id, form) => handler.put(`/contract-managements/spot-cost/${id}`, form),
  deleteSpotCost: (id) => handler.delete(`/contract-managements/spot-cost/${id}`),
  getSpotCostAttachment: (id) => handler.get(`/contract-managements/attachments/${id}`),
  getSpotCostsExcelDownload: params => handler.get('/contract-managements/spot-cost/download', { params, responseType: 'blob' }),

  // STA (Standard Time)
  getSTA: params => handler.get('/sta', { params }),
  postSTA: form => handler.post('/sta', form),
  putSTA: (id, form) => handler.put(`/sta/${id}`, form),
  deleteSTA: id => handler.delete(`/sta/${id}`),
  getSTAShippers: params => handler.get('/sta/shippers', { params }),
  getSTAColumns: params => handler.get('/sta/columns', { params }),
  getSTAYears: params => handler.get(`/sta/years`, { params }),
  getSTAExcelDownload: params => handler.get('/sta/download', { params, responseType: 'blob' }),
  postSTADuplicate: form => handler.post('/sta/duplicate', form),

  // Docking Schedule
  getDockingSchedules: (params) => handler.get('/docking-schedule', { params }),
  postDockingSchedule: (form) => handler.post('/docking-schedule', form),
  deleteDockingSchedule: (id) => handler.delete(`/docking-schedule/${id}`),
  putDockingSchedule: (id, form) => handler.put(`/docking-schedule/${id}`, form),
  getDockingScheduleDropdown: (params) => handler.get('/docking-schedule/dropdown', { params }),
  getDockingSchedulesExcelDownload: params => handler.get('/docking-schedule/download', { params, responseType: 'blob' }),
  postDockingScheduleSendEmail: form => handler.post('/docking-schedule/send-email', form),
  postDocumentTrackingReportSendEmail: form => handler.post('/document-tracking/send-email', form),

  // Plan Next Trip
  getIncomingFleets: params => handler.get('/plan-next-trip/tug-barge-combinations', { params }),
  getPlanNextTripDrafts: params => handler.get('/plan-next-trip', { params }),
  getDockingScheduleByCombination: (params) => handler.get('/plan-next-trip/docking-schedule', { params }),
  postPlanNextTripDraft: (id, form) => handler.post(`/plan-next-trip/${id}`, form),
  getPlanNextTripBlendingSchema: () => handler.get('/plan-next-trip/blending-schema'),
  postPlanNextTripGenerateToBLU: (id, form) => handler.post(`/plan-next-trip/${id}/generate-blu`, form),

  // Fuel Price
  getFuelPrices: params => handler.get('/fuel-prices', { params }),
  postFuelPrice: (form) => handler.post('/fuel-prices', form),
  putFuelPrice: (id, form) => handler.put(`/fuel-prices/${id}`, form),
  getFuelPricesExcelDownload: params => handler.get('/fuel-prices/download', { params, responseType: 'blob' }),

  // Fuel Supply Report
  getFuelSupplyReports: params => handler.get('/fuel-supply-reports', { params }),
  putFuelSupplyReport: (id, form) => handler.post(`/fuel-supply-reports/${id}`, form),
  getDailyBunkerReportExcelDownload: params => handler.get('/fuel-supply-reports/daily-bunker-report', { params, responseType: 'blob' }),
  getFuelSupplyReportExcelDownload: params => handler.get('/fuel-supply-reports/fuel-supply-report', { params, responseType: 'blob' }),
  postFuelSupplySendEmail: form => handler.post('/fuel-supply-reports/send-email', form),
  getDefaultEmailRecipients: params => handler.get('/fuel-supply-reports/default-email-recipients', { params }),

  // Hold Hatch Cleanliness
  getHoldHatchCleanliness: params => handler.get('/cleanliness-inspection', { params }),
  getHoldHatchCleanlinessDetails: (id, params) => handler.get(`/cleanliness-inspection/${id}`, { params }),
  getHoldHatchCleanlinessExcelDownload: params => handler.get('/cleanliness-inspection/summary-report', { params, responseType: 'blob' }),
  getHoldHatchCleanlinessDetailsExcelDownload: (id, params) => handler.get(`/cleanliness-inspection/detail-report/${id}`, { params, responseType: 'blob' }),

  // Quarterly Inspection Report
  getQuarterlyInspections: params => handler.get('/quarterly-inspections', { params }),
  postQuarterlyInspection: (form) => handler.post('/quarterly-inspections', form),
  putQuarterlyInspection: (id, form) => handler.put(`/quarterly-inspections/${id}`, form),
  deleteQuarterlyInspection: (id) => handler.delete(`/quarterly-inspections/${id}`),
  getQuarterlyInspectionStatus: () => handler.get('/quarterly-inspections/status-on-hire'),
  getQuarterlyInspectionItems: () => handler.get('/quarterly-inspections/inspection-items'),
  getQuarterlyInspectionDetail: (id) => handler.get(`/quarterly-inspections/${id}`),
  exportQuarterlyInspection: (params) => handler.get('/quarterly-inspections/download', { params, responseType: 'blob' }),
  downloadFileQuarterInspection: (id) => handler.get(`/quarterly-inspections/${id}/download`, { params: {}, responseType: 'blob' }),
  postQuarterlyInspectionSendEmail: form => handler.post('/quarterly-inspections/send-email', form),

  // Location Management
  getLocations: params => handler.get('/location-managements', { params }),
  getLocationTypes: params => handler.get('/location-managements/types', { params }),
  putLocations: (id, form) => handler.put(`/location-managements/${id}`, form),
  postLocations: (form) => handler.post('/location-managements', form),
  getLocationById: (id) => handler.get(`/location-managements/${id}`),
  deleteLocation: (id) => handler.delete(`/location-managements/${id}`),
  exportLocation: (params) => handler.get('/location-managements/download', { params, responseType: 'blob' }),  

  // Manage Activity
  getCheckpoints: (id, params) => handler.get(`/checkpoints/${id}/details`, { params }),
  postCheckpoint: (form) => handler.post('/checkpoints', form),
  putCheckpoint: (id, checkpoint_id, form) => handler.put(`/checkpoints/${id}/details/${checkpoint_id}`, form),
  deleteCheckpoint: (id, checkpoint_id) => handler.delete(`/checkpoints/${id}/details/${checkpoint_id}`),
  getActivities: (id, checkpoint_id, params) => handler.get(`/checkpoints/${id}/details/${checkpoint_id}/activities`, { params }),
  postActivity: (id, checkpoint_id, form) => handler.post(`/checkpoints/${id}/details/${checkpoint_id}/activities`, form),
  putActivity: (id, checkpoint_id, activity_id, form) => handler.put(`/checkpoints/${id}/details/${checkpoint_id}/activities/${activity_id}`, form),
  deleteActivity: (id, checkpoint_id, activity_id) => handler.delete(`/checkpoints/${id}/details/${checkpoint_id}/activities/${activity_id}`),

  // KPI TRACKING
  getBargeOverviewKpi: params => handler.get(`/kpi-tracking/barge-overview`, { params }),
  getFuelOptimizationKpi: params => handler.get(`/kpi-tracking/fuel-optimization`, { params }),
  getLoadingMonitoringKpi: params => handler.get(`/kpi-tracking/loading-monitoring`, { params }),
  getBargeMonitoringKpi: params => handler.get(`/kpi-tracking/barge-monitoring`, { params }),

  // Cycle Time Utilization
  getCycleTimeUtilization: params => handler.get(`/cycle-time-utilization`, { params }),
  getCycleTimeUtilRoutes: () => handler.get(`/cycle-time-utilization/routes`),
  getCycleTimeUtilBargeSizes: () => handler.get(`/cycle-time-utilization/barge-sizes`),

  // Incident Safety Utilization
  getIncidentSafetyUtilization: params => handler.get(`/incident-safety-utilization`, { params }),
  getIncidentSafetyUtilRoutes: () => handler.get(`/incident-safety-utilization/routes`),

  // Barge Cost Utilization
  getBargeCostUtilization: params => handler.get(`/barge-cost-utilization`, { params }),
  getBargeCostUtilRoutes: () => handler.get(`/barge-cost-utilization/routes`),

  // Cargo Capacity Utilization
  getCargoCapacityUtilization: params => handler.get('/cargo-capacity-utilization', { params }),
  getCargoCapacityUtilRoutes: () => handler.get(`/cargo-capacity-utilization/routes`),

  // On-Time Performance Utilization
  getOnTimePerformanceUtilization: params => handler.get('/on-time-performance', { params }),
  getOnTimePerformanceUtilRoutes: () => handler.get(`/on-time-performance/routes`),

  // Fuel Supply Management Utilization
  getFuelSupplyUtilization: params => handler.get('/fuel-supply-management', { params }),
  getFuelSupplyUtilRoutes: () => handler.get(`/fuel-supply-management/routes`),

  // Barge Measurement Performance
  getBargeMeasurementPerformance: params => handler.get('/qctse-dashboard', { params }),
  
  // Cost Analysis
  getMajorAssumptions: params => handler.get(`/cost-analysis/major-assumption`, { params }),
  getLogisticCost3rdPartyCoal: params => handler.get(`/cost-analysis/logistic-cost-third-party-coal`, { params }),
  getBargeLogisticTargetMonitoring: params => handler.get(`/cost-analysis/barge-logistic-target-monitoring`, { params }),
  getLogisticCostPerActivity: params => handler.get(`/cost-analysis/logistic-cost-per-activity`, { params }),
  getTotalLogisticCost: params => handler.get(`/cost-analysis/total-logistic-cost`, { params }),

  // Azure Auth
  exchangeToken: token => handler.post(`/auth/login-azure`, null, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }),

  // Cargo Contamination
  getCargoContaminations: params => handler.get('/cargo-contamination', { params }),
  exportCargoContamination: params => handler.get('/cargo-contamination/download-ssrs', { params, responseType: 'blob' }),

  // Cargo Stolen
  getCargoStolen: params => handler.get('/cargo-stolen', { params }),
  getCargoStolenById: id => handler.get(`/cargo-stolen/${id}`),
  putCargoStolen: (id, form) => handler.put(`/cargo-stolen/${id}`, form),
  postCargoStolenFiles: form => handler.post(`/cargo-stolen/upload/files`,  form),
  getVesselCargoStolen: params => handler.get('/cargo-stolen/vessel', { params }),
  getCargoStolenExport: params => handler.get('/cargo-stolen/download-ssrs', { params, responseType: 'blob' }),
  postCargoStolenSendEmail: form => handler.post('/cargo-stolen/send-email', form),
  getPercentageCargoStolenChart: params => handler.get('/cargo-stolen/percentage-chart', { params }),
  getSummaryCargoStolen: params => handler.get('/cargo-stolen/summary-report', { params }),

  // Checklist Monitoring
  getChecklistMonitoring: params => handler.get('/checklist-monitoring', { params }),
  getChecklistMonitoringExport: params => handler.get('/checklist-monitoring/download-ssrs', { params, responseType: 'blob' }),

  // MFA Auth
  sendOtpCode: form => handler.post('/auth/login-otp', form),
  verifyOtpCode: form => handler.post('/auth/verify-code', form),
  resendOtpCode: form => handler.post('/auth/resend-code', form),

  // Bridge Schedule
  getBridgeSchedule: params => handler.get('/bridge-schedules', { params }),
  postBridgeSchedule: form => handler.post('/bridge-schedules', form),
  putBridgeSchedule: (id, form) => handler.put(`/bridge-schedules/${id}`, form),
  deleteBridgeSchedule: (id) => handler.delete(`/bridge-schedules/${id}`),
  getBridgeScheduleExcelDownload: params => handler.get('/bridge-schedules/download', { params, responseType: 'blob' }),

  // Vessel Management
  getVesselManagements: params => handler.get('/vessels', { params }),
  postVesselManagement: form => handler.post('/vessels', form),
  putVesselManagement: (id, form) => handler.put(`/vessels/${id}`, form),
  deleteVesselManagement: (id) => handler.delete(`/vessels/${id}`),
  getVesselManagementExcelDownload: params => handler.get('/vessels/download', { params, responseType: 'blob' }),
  getVesselCheckExist: (id, params) => handler.get(`/vessels/check-existing/${id}`, { params }),

  // Tentative Barge Schedule
  getTentativeBargeSchedules: (id) => handler.get(`/tentative-barge-schedules/${id}`),
  getTentativeBargeScheduleDetails: (id) => handler.get(`/tentative-barge-schedules/detail/${id}`),
  putTentativeBargeSchedules: (id, form) => handler.put(`/tentative-barge-schedules/${id}`, form),
  storeTentativeBargeScheduleDetail: (form) => handler.post(`/tentative-barge-schedules/detail`, form),
  getTentativeBargeScheduleExcel: (params) => handler.get('/tentative-barge-schedules/download-ssrs', { params, responseType: 'blob' }),

  // OEE Items Management
  getOEEItems: params => handler.get('/oee-masters', { params }),
  postOEEItem: (form) => handler.post('/oee-masters', form),
  putOEEItem: (id, form) => handler.put(`/oee-masters/${id}`, form),
  deleteOEEItem: (id) => handler.delete(`/oee-masters/${id}`),
  getOEEItemExcelDownload: params => handler.get('/oee-masters/download', { params, responseType: 'blob' }),

  // Exchange Rate
  getExchangeRate: params => handler.get('/exchange-rates', { params }),
  postExchangeRate: (form) => handler.post('/exchange-rates', form),
  putExchangeRate: (id, form) => handler.put(`/exchange-rates/${id}`, form),
  getExchangeRateExcelDownload: params => handler.get('/exchange-rates/download', { params, responseType: 'blob' }),

  // Site Management
  getSiteManagements: (params) => handler.get('/sites', { params }),
  getSiteManagementsExcelDownload: (params) => handler.get('/sites/download', { params, responseType: 'blob' }),
  postSiteManagement: (form) => handler.post('/sites', form),
  putSiteManagement: (id, form) => handler.put(`/sites/${id}`, form),
  deleteSiteManagement: (id) => handler.delete(`/sites/${id}`),

  // Dashboard Options
  getRouteOpt: params => handler.get('/dashboard/routes', { params }),
  getOwnerOpt: params => handler.get('/dashboard/owners', { params }),
  getHorsePowerOpt: params => handler.get('/dashboard/horse-powers', { params }),
  getBargeSizeOpt: params => handler.get('/dashboard/barge-sizes', { params }),
  getSiteOpt: params => handler.get('/dashboard/sites', { params }),

  getUserNotifications: params => handler.get('/notification-users', { params }),

  // Menu Management
  getMenuConfigurations: () => handler.get('/menu/configurations'),
  getMenuFeatures: () => handler.get('/menu/features'),
  uploadMenuIcon: (form) => handler.post('/menu/attachments', form ),
  putMenuConfiguration: (from) => handler.put('/menu/configurations', from),

  // Tug Barges Performance
  getTugBargesPerformanceDetails: (id, params) => handler.get(`/tug-barges/performance-details/${id}`, { params }),
  postTugBargesPerformance: (form) => handler.post('/tug-barges/performance-details', form),
  getTugBargesPerformance: (params) => handler.get(`/tug-barges/performance-details`, { params }),
  getTugBargesPerformanceChart: (params) => handler.get(`/tug-barges/performance-details/chart`, { params }),
  getTugBargesPerformanceReport: (params) => handler.get(`/tug-barges/performance-details/report`, { params, responseType: 'blob' })
})
